module.exports = __webpack_public_path__ + "img/icon_left_0.3c4429a6.png";